import { render, staticRenderFns } from "./LeakInvestigationReports.vue?vue&type=template&id=b37e269e"
import script from "./LeakInvestigationReports.vue?vue&type=script&setup=true&lang=js"
export * from "./LeakInvestigationReports.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports